import { Suspense, useState, useEffect, lazy } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import Loader from 'components/Common/Loader';

import routes from 'routes';
import adminRoutes from 'routes/admin';

import { RLThemeProvider } from 'rlui/styled';
import { adminTheme, executorTheme } from './theme';

import Footer from 'components/Executor/Footer';

import { MdOutlineHistory } from 'react-icons/md';
import { IconButton, Box, Image } from '@chakra-ui/react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallbackUi from 'components/Common/ErrorFallbackUi';
import useAuthStore from 'store/authStore';
import PrivateRoute from 'routes/PrivateRoute';
import powered from 'assets/img/powered.svg';
const Login = lazy(() => import('pages/Login'));

const AdminRouter = () => {
	const location = useLocation();
	const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
	const themeMode = location.pathname.includes('admin')
		? adminTheme
		: executorTheme;
	return (
		<RLThemeProvider theme={themeMode}>
			<ErrorBoundary
				fallbackRender={({ error, resetErrorBoundary }) => (
					<ErrorFallbackUi
						hasGoback={true}
						error={error.message}
						refetch={resetErrorBoundary}
					/>
				)}
			>
				<Switch>
					<Route path='/login' exact component={Login} />
					{routes.map((e) => {
						return (
							// <PrivateRoute path='/' isAuthenticated={isLoggedIn}>
							<Route key={e.path} exact path={e.path} component={e.component} />
							// </PrivateRoute>
						);
					})}
					{adminRoutes.map((e) => {
						return (
							// <PrivateRoute path='/admin' isAuthenticated={isLoggedIn}>
							<Route key={e.path} exact path={e.path} component={e.component} />
							// </PrivateRoute>
						);
					})}
				</Switch>

				<Image
					h='32px'
					w='auto'
					src={powered}
					position={'absolute'}
					zIndex={9}
					bottom={'20px'}
					right={20}
				/>
			</ErrorBoundary>
		</RLThemeProvider>
	);
};

function App() {
	const location = useLocation();
	console.log({ location });

	const [hideFooter, setHideFooter] = useState<boolean>(true);
	const isLoggedIn = useAuthStore((state) => state.isLoggedIn);

	const toggleHistoryHandler = (v = true) => {
		localStorage.setItem('useapiTime', v ? 'false' : 'true');
		setHideFooter(v);
		if (v) {
			window.location.reload();
		}
	};

	useEffect(() => {
		const shouldUseTimeFromLocalStorage =
			localStorage.getItem('useapiTime') ?? 'false';
		if (!JSON.parse(shouldUseTimeFromLocalStorage)) {
			setHideFooter(true);
		} else {
			setHideFooter(false);
		}
	}, []);

	return (
		<Suspense fallback={<Loader />}>
			{/* <Switch>
				<Route path={'/login'} exact component={Login} />
			</Switch> */}

			{isLoggedIn || location.pathname.includes('/preview/') ? (
				<AdminRouter />
			) : (
				<Login />
			)}
			<RLThemeProvider theme={executorTheme}>
				<Box position='fixed' bottom='0' zIndex={9}>
					{hideFooter ? (
						<IconButton
							variant='outline'
							borderRadius={20}
							border='none'
							m={10}
							aria-label='Show footer'
							backgroundColor='green.200'
							icon={<MdOutlineHistory size={20} color='white' />}
							onClick={() => toggleHistoryHandler(false)}
						/>
					) : (
						<Footer
							setHideFooter={(v) => toggleHistoryHandler(v)}
							refetch={() => {}}
						/>
					)}
				</Box>
			</RLThemeProvider>
			{/* <RLThemeProvider theme={executorTheme}>
				<ErrorBoundary
					fallbackRender={({ error, resetErrorBoundary }) => (
						<ErrorFallbackUi
							hasGoback={true}
							error={error.message}
							refetch={resetErrorBoundary}
						/>
					)}
				>
					<Switch>
						{routes.map((e) => {
							return (
								<Route
									key={e.path}
									// exact
									path={e.path}
									component={e.component}
								/>
							);
						})}
					</Switch>
				</ErrorBoundary>
			</RLThemeProvider>
			<RLThemeProvider theme={adminTheme}>
				<ErrorBoundary
					fallbackRender={({ error, resetErrorBoundary }) => (
						<ErrorFallbackUi
							hasGoback={true}
							error={error.message}
							refetch={resetErrorBoundary}
						/>
					)}
				>
					<Switch>
						{adminRoutes.map((e) => {
							return (
								<Route
									key={e.path}
									exact
									path={e.path}
									component={e.component}
								/>
							);
						})}
					</Switch>
				</ErrorBoundary>
			</RLThemeProvider> */}
			{/* <Box position='fixed' bottom='0' zIndex={9}>
				{hideFooter ? (
					<IconButton
						variant='outline'
						borderRadius={20}
						border='none'
						m={10}
						aria-label='Show footer'
						backgroundColor='green.200'
						icon={<MdOutlineHistory size={20} color='white' />}
						onClick={() => toggleHistoryHandler(false)}
					/>
				) : (
					<Footer
						setHideFooter={(v) => toggleHistoryHandler(v)}
						refetch={() => {}}
					/>
				)}
			</Box> */}
		</Suspense>
	);
}

export default App;
